import { IBlockchainEntity } from '@ankr.com/chains-list';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { web3Api } from 'store/queries';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchBlockchains },
  useFetchBlockchainsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchBlockchains: build.query<IBlockchainEntity[], void>({
      queryFn: createNotifyingQueryFn(async () => {
        const service = MultiService.getService();

        const chains = await service.getPublicGateway().getBlockchains();

        return {
          data: chains,
        };
      }),
    }),
  }),
});
